import React, { useState, useEffect } from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import { useParams } from "react-router-dom";
import { fetchData } from "../../services/apiServices";

const User = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetchData(`api/v2/admin/auth/users/${id}`);
        if (response && response.status) {
          setUserData(response.data);
        } else {
          setError(response.message || "Failed to fetch user data");
        }
      } catch (err) {
        console.error("Failed to fetch user data:", err);
        setError("Failed to fetch user data");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchUserData();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;
  if (!userData)
    return <div className="alert alert-warning">No user data found</div>;

  return (
    <div>
      {/* User Information Card */}
      <Card className="mb-4">
        <CardBody>
          <h4 className="card-title mb-4">User Information</h4>
          <Row>
            <Col md={6}>
              <div className="table-responsive">
                <table className="table table-nowrap mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">ID:</th>
                      <td>{userData._id}</td>
                    </tr>
                    <tr>
                      <th scope="row">Username:</th>
                      <td>{userData.userName || "N/A"}</td>
                    </tr>
                    <tr>
                      <th scope="row">Name:</th>
                      <td>
                        {userData.firstName || userData.lastName
                          ? `${userData.firstName || ""} ${userData.lastName || ""}`
                          : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Email:</th>
                      <td>{userData.email || "-"}</td>
                    </tr>
                    <tr>
                      <th scope="row">Phone Number:</th>
                      <td>{userData.phone_number || "N/A"}</td>
                    </tr>
                    <tr>
                      <th scope="row">Join Date:</th>
                      <td>{new Date(userData.createdAt).toLocaleString()}</td>
                    </tr>
                    <tr>
                      <th scope="row">Last Updated:</th>
                      <td>{new Date(userData.updatedAt).toLocaleString()}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Col>
            <Col md={6}>
              <div className="text-center">
                <img
                  src={userData.profileImage || "/default-profile.png"}
                  alt="Profile"
                  className="rounded-circle"
                  style={{
                    width: "150px",
                    height: "150px",
                    objectFit: "cover",
                  }}
                />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export default User;
